import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { BrowserRouter } from "react-router-dom";

import AuthService from "./auth/AuthService";
import axios from "axios";
import ScrollTop from "./components/ScrollTop/ScrollTop";
import { isMaintenancePeriod } from "./utils/maintenance";

let appRef;
const paymentPath = "/pagamento";

axios.interceptors.request.use(async (request) => {
  const bypassUrls = ["https://api.ipify.org?format=json"];
  if (bypassUrls.includes(request.url)) {
    return request;
  }
  appRef.setState({
    context: {
      ...appRef.state.context,
      error: {
        internalError: null,
      },
    },
  });

  const token = await AuthService.configureRequest(request);
  if (token != null) {
    request.headers["Authorization"] = `Bearer ${token}`;
    request.headers["x-ibm-client-id"] = process.env.REACT_APP_CLIENT_ID;
    request.headers["Content-Type"] = "application/json";
    request.headers["X-Robots-Tag"] = process.env.REACT_APP_ROBOTS;
  }
  appRef.setState({
    loading: true,
  });
  return request;
});

axios.interceptors.response.use(
  (response) => {
    appRef.setState({
      loading: false,
    });
    return response;
  },
  (error) => {
    if (error.config && error.response && error.response.status === 401) {
      return AuthService.fetchAuthToken().then((token) => {
        AuthService.accessToken = token;
        error.config.headers["Authorization"] = `Bearer ${token}`;
        error.config.headers["x-ibm-client-id"] =
          process.env.REACT_APP_CLIENT_ID;
        error.config.headers["Content-Type"] = "application/json";
        error.config.headers["X-Robots-Tag"] = process.env.REACT_APP_ROBOTS;
        return axios.request(error.config);
      });
    } else if (isMaintenancePeriod()) {
      appRef.setState({
        context: {
          ...appRef.state.context,
          error: {
            show: false,
            internalError: () => {
              return "Nossos sistemas estão passando por manutenção preventiva nesse período. Voltaremos à normalidade no próximo dia 13/10. Agradecemos a compreensão.";
            },
          },
        },
      });
      window.scroll(0, 0);
    } else if (
      error.response &&
      appRef.state.context.pathname !== paymentPath &&
      error.response.status === 400
    ) {
      if (appRef.state.context.pathname === "/dados-cliente") {
        appRef.setState({
          context: {
            ...appRef.state.context,
            error: {
              show: true,
              msg: error.response.data.httpMessage,
            },
          },
        });
      } else if (appRef.state.context.pathname !== paymentPath) {
        appRef.setState({
          context: {
            ...appRef.state.context,
            error: {
              show: false,
              internalError: () => {
                return error.response.data.httpMessage;
              },
            },
          },
        });
      }
    } else if (
      appRef.state.context.pathname !== paymentPath &&
      error.response && error.response.config.url.includes("consentimentos")) {
        appRef.setState({
          context: {
            ...appRef.state.context,
            error: {
              show: false,
            },
          },
        });
    } else {
      appRef.setState({
        context: {
          ...appRef.state.context,
          error: {
            show: false,
            internalError: () => {
              return "Nossos serviços estão temporariamente indisponíveis. Pedimos que tente novamente mais tarde.";
            },
          },
        },
      });
    }

    appRef.setState({
      loading: false,
    });
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <BrowserRouter basename="/consorcio">
    <ScrollTop>
      <App
        ref={(app) => {
          appRef = app;
        }}
      />
    </ScrollTop>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
